import React, { forwardRef, MouseEvent } from 'react';

interface MobileListItemGoBackBtnProps {
  level: number;
  text: string;
}

export const MobileListItemGoBackBtn = forwardRef<HTMLLIElement, MobileListItemGoBackBtnProps>(
  ({ level, text }, ref) => {
    const goBack = (event: MouseEvent<HTMLLIElement>) => {
      const menuList = document.getElementsByClassName('mm-mobile-ul');
      const menu: Element[] = Array.prototype.slice.call(menuList);
      if (level <= 1) {
        const mobileMenu = document.getElementById('mobile-megamenu');
        if (mobileMenu) {
          if (menu) {
            menu.forEach((element) => {
              if (element) element.classList.add('hidden');
            });
          }
          mobileMenu.classList.forEach((className) => {
            if (className.startsWith('move')) {
              mobileMenu.classList.remove(className);
              mobileMenu.classList.add('move-from-right');
            }
          });
        }
      } else {
        const targetEl = event.currentTarget;
        if (targetEl) {
          const id = targetEl.getAttribute('data-mm-mobileback-id');
          if (id) {
            const el = document.getElementById(id);
            if (el) {
              if (menu) {
                menu.forEach((element) => {
                  if (element != el) element.classList.add('hidden');
                });
              }
              el.classList.remove('hidden');
              el.classList.forEach((className) => {
                if (className.startsWith('move')) {
                  el.classList.remove(className);
                  el.classList.add('move-from-right');
                }
              });
            }
          }
        }
      }
    };

    return (
      <li ref={ref} className='l-header-mobile-menu-item mobile-mm-header-back' onClick={goBack}>
        <span className='back mobile-back-mm'>
          <i className='icon-angle-left' />
          {text}
        </span>
      </li>
    );
  }
);
